import FolderCard from '@wix/da-shared-react/pkg/FolderCard';
import FolderCardContainer from './FolderCard.container';

export default FolderCardContainer(FolderCard)
